import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { LABELS_COLUMN_BACKGROUND_COLOR } from '../items/consts';
import { text2 } from '@ardoq/typography';
import { GRID_LABELS_BOTTOM_ROW_HEIGHT, TIMELINE_GRID_COLOR } from './consts';

const ChartGridVisual = styled.div`
  position: absolute;
  z-index: 1;
  pointer-events: none;
`;
export const TodayTriangle = styled(ChartGridVisual)`
  z-index: 4;
  width: 0;
  height: 0;
  border-top: 8px solid ${colors.brand700};
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  translate: -8px 0;
`;
export const XGridLine = styled(ChartGridVisual)`
  border-left-width: 1px;
  border-left-style: solid;
  height: 100%;
  min-height: 100%;
`;
export const FrontGridline = styled(XGridLine)`
  z-index: 4;
`;

export const TodayLine = styled(FrontGridline)`
  border-left-color: ${colors.brand700};
  border-left-width: 2px;
  transform: translateX(-1px);
  height: unset;
  min-height: unset;
`;

export const XAxisText = styled.div`
  position: absolute;
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  pointer-events: none;
  margin-bottom: 0px;
  color: ${colors.grey500};
  ${text2};
`;

export const LabelColumnBackground = styled.div`
  position: absolute;
  background-color: ${LABELS_COLUMN_BACKGROUND_COLOR};
  top: 0;
  z-index: 5;
  height: ${GRID_LABELS_BOTTOM_ROW_HEIGHT}px;
`;

export const TickLabelRowContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${GRID_LABELS_BOTTOM_ROW_HEIGHT}px;
`;

export const XAxisLine = styled.div`
  border-top: 1px solid ${TIMELINE_GRID_COLOR};
  position: absolute;
  top: ${GRID_LABELS_BOTTOM_ROW_HEIGHT}px;
  height: 1px;
`;

export const XAxisTickmark = styled.div`
  border-left: 1px solid ${TIMELINE_GRID_COLOR};
  position: absolute;
  height: 100%;
  width: 1px;
`;
